import { useState, useCallback } from 'react';

/**
 * Custom hook for managing toast notifications
 * 
 * Usage:
 * const { toasts, showToast, removeToast } = useToast();
 * 
 * showToast('Upload successful!', 'success');
 * showToast('Upload failed', 'error', 8000);
 */
const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 5000) => {
    const id = Date.now() + Math.random();
    
    const newToast = {
      id,
      message,
      type,
      duration
    };

    setToasts((prev) => [...prev, newToast]);

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev?.filter((toast) => toast?.id !== id));
  }, []);

  const clearAllToasts = useCallback(() => {
    setToasts([]);
  }, []);

  return {
    toasts,
    showToast,
    removeToast,
    clearAllToasts
  };
};

export default useToast;